// components/PageTitleUpdater.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const routeTitleMap = {
  "/user/home": "Home",
  "/user/chat": "Chat",
  "/user/new": "Chat",
  "/user/imagetotext": "Image to Text",
  "/user/imagetovideo": "Image to Video",
  "/user/audiototext": "Audio to Text",
  "/user/audiotoaudio": "Audio to Audio",
  "/user/audiotochat": "Audio to Chat",
  "/user/pdftoall": "PDF Toolkit",
  "/user/activity-log": "Activity Log",
  "/superadmin/enterprise": "Enterprise",
  "/superadmin/activity-log": "Activity Log",
  "/superadmin/role-management": "Role Management",
  "/superadmin/module": "Module Management",
  "/superadmin/users": "User Management",
  //   "/admin/role-management": "Role Management",
  "/admin/activity-log": "Activity Log",
  "/": "Login",
  "/forgot-password": "Forgot Password",
  "/verify-email": "Verify Email",
  "/reset-password": "Reset Password",
};

export default function PageTitleUpdater() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    const title = routeTitleMap[path] || "Domatrix App";
    document.title = `Domatrix | ${title} `;
  }, [location.pathname]);

  return null;
}
